import React from 'react'
import { Skeleton } from '@mui/material';

const SkeletonWorkSchedule = () => {
    return (
        <>
            {[...Array(8)].map((_) => (
                <Skeleton variant="rectangular" sx={{ mb: 1 }} height={60} />
            ))}
        </>
    )
}
export default SkeletonWorkSchedule;
